import useAdditionalGroupsSelect from 'modules/additional-groups/hooks/use-additional-groups-select';
import useCreateAdditional from 'modules/additionals/hooks/use-create-additional';
import {
  AdditionalProps,
  translatedAdditionalProps,
} from 'modules/additionals/types';
import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateAdditional: React.FC = () => {
  const {
    getInput,
    getSwitch,
    getSelect,
    getTextArea,
    getPriceInput,
    getImagePicker,
  } = useFormInputs<AdditionalProps>();
  const {data, isLoading} = useAdditionalGroupsSelect();

  const handleSubmit = (data: AdditionalProps) => {
    const formData = new FormData();

    formData.append('name', data.name);
    formData.append('description', data.description ?? '');
    formData.append('price', String(data.price));
    formData.append('additionalGroupId', data.additionalGroupId);
    formData.append('active', String(data.active));
    if (data.image && (data.image as any) instanceof File)
      formData.append('image', data.image);

    return formData;
  };

  return (
    <Creation<AdditionalProps>
      titleBar={{title: 'Cadastrar adicional'}}
      onSubmit={useCreateAdditional}
      defaultValues={{active: true}}
      handleSubmit={handleSubmit}
      inputs={[
        getInput({
          name: 'name',
        }),
        getTextArea({name: 'description'}),
        getSwitch({
          name: 'active',
        }),
        getPriceInput({name: 'price'}),
        getSelect({name: 'additionalGroupId', data, isLoading}),
        getImagePicker({name: 'image', label: 'Imagem'}),
      ]}
      translationKey={translatedAdditionalProps}
    />
  );
};

export default CreateAdditional;
